import { IBaseProps, IValueData } from '../../types/data';

export interface IOYRadioCheckboxProps extends IBaseProps {
  value: string[];
  info: IValueData[];
  display?: 'card' | 'text';
  cardHeight?: number;
  width?: number;
  cells?: number;
  subKey?: string;
  /**
   * 文本最大长度
   */
  maxTextLength?: number;
  /**
   * 渲染默认样式
   * @param data
   */
  renderItem?(data: IValueData): string;
  /**
   * 渲染card卡片样式item.当card为true时生效
   * @param data
   */
  renderCardItem?(data: IValueData): string;
  /**
   * 渲染副标题.当card为true时生效
   * @param value
   */
  renderSub?(value: string): string;
}

export interface IOYRadioCheckboxState {
  width: string;
  tags: IValueData[],
  inputData: string[]
}

export enum ERadioCheckboxDisplay {
  /** 显示为文本样式 */
  Text = 'text',
  /** 显示为卡片样式 */
  Card = 'card'
}



// WEBPACK FOOTER //
// ./src/components/OYRadioCheckbox/const.ts